import React from 'react';

// styles
import {
  MissionBannerWrapper,
  MissionBannerContainer,
  MissionBannerContent,
  StyledTitle,
  StyledDescription,
} from './MissionBanner.styles';

export function MissionBanner({ content }) {
  return (
    <MissionBannerWrapper>
      <MissionBannerContainer>
        <MissionBannerContent>
          <StyledTitle>{content.title}</StyledTitle>
          <StyledDescription>{content.description}</StyledDescription>
        </MissionBannerContent>
      </MissionBannerContainer>
    </MissionBannerWrapper>
  );
}
